import React from "react";
import ct from "class-types.macro";
import LoginLink from "./LoginLink";
import ChatLink from "./ChatLink";
import { VariantProps } from ".";
import Standard from "../Price";
const T = (props: VariantProps) => {
  const {
    selectedProduct,
    productListingView
  } = props;
  return <div className="map map-override mapT" data-sentry-component="T" data-sentry-source-file="T.tsx">
      <Standard price={selectedProduct.price.price} unitOfMeasure={selectedProduct.unitOfMeasure} data-sentry-element="Standard" data-sentry-source-file="T.tsx" />
      <p className={ct("font-semibold", "text-xs", "leading-none", "mb-2", "text-gray-800", productListingView === "list" ? ct("mt-1", "p-0", "pb-1", "xs:m-0", "xs:text-center") : ct("p-0", "pt-1", "text-center"))}>
        {selectedProduct.showBelowMinimumAdvertisedPriceForLoggedInCustomers ? <>
            {"Contact us or "}
            <LoginLink>login</LoginLink>
            <br />
            {" for pricing"}
            <ChatLink productListingView={productListingView} />
          </> : <>
            Contact us for pricing
            <ChatLink productListingView={productListingView} />
          </>}
      </p>
    </div>;
};
export default T;